var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 15,
    viewBox: "0 0 77 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4062",
    "data-name": "Group 4062",
    transform: "translate(0 2.449)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 77,
    height: 15,
    rx: 3,
    transform: "translate(0 -2.449)",
    fill: "#f5ca3d"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Under_Verification",
    "data-name": "Under Verification",
    transform: "translate(3 7.551)",
    fontSize: 8,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Under Verification")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderVerification);
export default __webpack_public_path__ + "static/media/underVerification.c7ea3193e8cb593266e7c0cb8854eecb.svg";
export { ForwardRef as ReactComponent };